var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block",class:{
  'block--left': _vm.left,
  'block--right': _vm.right,
},style:({
  maxWidth: _vm.maxWidth,
  flex: ("1 1 " + _vm.maxWidth),
})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }